import { getErrorMessage } from '../../utils/errorMessage';
import { useCallback, useEffect, useState } from 'react';
import { Check, Gift, RefreshCw, Sparkles } from 'lucide-react';
import { getRedeemHistory, redeemCode, rewardApiError } from './rewardApi';

const formatDate = value => value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '-';

export default function RewardsCenterPanel({ preview = false, english = false, onRedeemed }) {
  const [code, setCode] = useState('');
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(!preview);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const load = useCallback(async () => {
    if (preview) return;
    setLoading(true); setError('');
    try { const response = await getRedeemHistory(); setHistory(response?.list || []); }
    catch (requestError) { setError(getErrorMessage(rewardApiError(requestError, '兑换记录加载失败'))); }
    finally { setLoading(false); }
  }, [preview]);
  useEffect(() => { load(); }, [load]);

  const submit = async event => {
    event.preventDefault();
    const normalized = code.trim().toUpperCase();
    if (!normalized) { setError('请输入兑换码'); return; }
    setSubmitting(true); setError(''); setResult(null);
    try {
      const response = await redeemCode(normalized);
      setResult(response); setCode(''); await load();
      if (onRedeemed) await onRedeemed();
    } catch (requestError) { setError(getErrorMessage(rewardApiError(requestError, '兑换失败，请稍后重试'))); }
    finally { setSubmitting(false); }
  };

  return <div className="account-content__stack rewards-panel">
    <section className="account-page-heading rewards-panel__heading"><div><h1>{english ? 'Rewards' : '奖励中心'}</h1><p>{english ? 'Redeem a code and review recent rewards.' : '输入兑换码领取奖励，成功积分会立即进入当前账户。'}</p></div></section>
    <section className="rewards-redeem-card">
      <span className="rewards-redeem-card__icon"><Gift size={19} /></span>
      <div className="rewards-redeem-card__copy"><h2>兑换奖励</h2><p>兑换码不区分大小写；每个兑换码的次数和有效期以活动规则为准。</p></div>
      <form onSubmit={submit} noValidate><label htmlFor="redeem-code">兑换码</label><div><input id="redeem-code" maxLength="64" autoComplete="off" value={code} onChange={event => setCode(event.target.value.toUpperCase())} placeholder="例如：XIAOYING2026" /><button type="submit" disabled={preview || submitting}>{submitting ? <><RefreshCw className="rewards-spin" size={13} />兑换中…</> : <><Sparkles size={13} />立即兑换</>}</button></div></form>
      {error && <p className="rewards-feedback is-error" role="alert">{error}</p>}
      {result && <div className="rewards-feedback is-success" role="status"><Check size={15} /><div><strong>兑换成功，已领取 {result.prize_name}</strong><span>到账 {result.prize_value} 积分，当前余额 {result.balance}</span></div></div>}
    </section>
    <section className="rewards-history"><header><div><h2>最近兑换</h2><p>保留最近 20 条成功或失败记录。</p></div><button type="button" onClick={load} disabled={preview || loading}><RefreshCw size={12} />刷新</button></header>
      {loading ? <div className="rewards-history__state">正在加载兑换记录…</div> : history.length === 0 ? <div className="rewards-history__state">还没有兑换记录</div> : <div className="rewards-history__list">{history.map(item => <article key={item.id}><span className={`rewards-history__status ${item.status === 1 ? 'is-success' : 'is-failed'}`}>{item.status === 1 ? '成功' : '失败'}</span><div><strong>{item.prize_name || item.code}</strong><small>{item.code} · {formatDate(item.created_at)}</small></div><span>{item.status === 1 ? `${item.prize_value || '-'} 积分` : getErrorMessage(item.fail_reason, '兑换失败，请稍后重试。')}</span></article>)}</div>}
    </section>
  </div>;
}
